import { RedeemIcon, LocalMallIcon, FuelRollbackIcon } from '@occc-app/design-system';
import { OfferSchema } from '@occc-app/offerValidationService/types';
import {
  promotionProductDiscountSchema,
  promotionTransactionDiscountSchema,
  promotionVarietyDiscountSchema,
  promotionBogoSchema,
  promotionFuelRollbackSchema,
} from '@occc-app/offerValidationService/schemas';
import { OfferTypeSelectProps } from '@occc-app/routes/CampaignComponents/components/OfferTypeSelect/OfferTypeSelect';
import { Award_Per_Counting_Strategy } from '@occc/graphql';
import { PromotionType } from './types';

export const promotionTypes: OfferTypeSelectProps['items'] = [
  {
    type: PromotionType.ProductDiscount,
    title: 'Product Discount',
    description: 'Provide a discount on specific products when members purchase specified products',
    icon: RedeemIcon,
  },
  {
    type: PromotionType.FuelRollback,
    title: 'Fuel Rollback',
    description: 'Provide fuel price rollback discounts to members at the pump',
    icon: FuelRollbackIcon,
  },
  {
    type: PromotionType.TransactionDiscount,
    title: 'Transaction Discount',
    description:
      'Provide discounts on the entire transaction when members purchase specified products',
    icon: RedeemIcon,
  },
  {
    type: PromotionType.VarietyDiscount,
    title: 'Variety Discount',
    description:
      'Provide discounts on product or transactions when members purchase multiple products',
    icon: LocalMallIcon,
  },
  {
    type: PromotionType.BuyAndGet,
    title: 'BOGO',
    description: 'Provide free products when members buy the same products',
    icon: LocalMallIcon,
  },
];

export const offerSchemaByType: Record<PromotionType, OfferSchema> = {
  [PromotionType.ProductDiscount]: promotionProductDiscountSchema,
  [PromotionType.TransactionDiscount]: promotionTransactionDiscountSchema,
  [PromotionType.VarietyDiscount]: promotionVarietyDiscountSchema,
  [PromotionType.BuyAndGet]: promotionBogoSchema,
  [PromotionType.FuelRollback]: promotionFuelRollbackSchema,
};

export const countProductsByOptions = [
  { label: 'Quantity', value: Award_Per_Counting_Strategy.IndividualPurchase },
  { label: 'Selling Units', value: Award_Per_Counting_Strategy.SellingUnitPurchase },
];

export const supportedOrderAheadPromotionTypes: PromotionType[] = [
  PromotionType.ProductDiscount,
  PromotionType.TransactionDiscount,
  PromotionType.VarietyDiscount,
  PromotionType.BuyAndGet,
];

export const promotionTypesSupportingTransactionFrequencyLimit: PromotionType[] = [
  PromotionType.ProductDiscount,
  PromotionType.TransactionDiscount,
  PromotionType.VarietyDiscount,
  PromotionType.BuyAndGet,
  PromotionType.FuelRollback,
];

export const requiresActivationApplicablePromotionTypes: PromotionType[] = [
  PromotionType.ProductDiscount,
  PromotionType.TransactionDiscount,
  PromotionType.VarietyDiscount,
  PromotionType.BuyAndGet,
];
